import * as React from "react";

import styles from "../styles/Nav.module.scss";

import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";

import Menu from "./MenuAcess"

import DehazeOutlinedIcon from "@mui/icons-material/DehazeOutlined";
import { useWindowSize } from "../hooks/useWindowSize";

import Logo from '../components/Logo'
import Link from "next/link";
import { withRouter } from "next/router";

import iconeResidencial from "../assets/images/residencialMobile.svg"
import iconeEmpresarial from "../assets/images/empresarialMobile.svg"
import iconeVida from "../assets/images/vidaMobile.svg"
import iconeOdonto from "../assets/images/odontoMobile.svg"
import iconeBike from "../assets/images/bikeMobile.svg"
import iconeAuto from "../assets/images/autoMobile.svg"

type Anchor = "top" | "left" | "bottom" | "right";

const Header = ({ router }) => {

  const size = useWindowSize();

  const [user, setUser] = React.useState()

  const [state, setState] = React.useState({
    right: false,
  });

  const toggleDrawer =
    (anchor: Anchor, open: boolean) =>
      (event: React.KeyboardEvent | React.MouseEvent) => {
        if (
          event.type === "keydown" &&
          ((event as React.KeyboardEvent).key === "Tab" ||
            (event as React.KeyboardEvent).key === "Shift")
        ) {
          return;
        }

        setState({ ...state, [anchor]: open });
      };

  const list = (anchor: Anchor) => (
    <Box
      sx={{
        width: '100%',
        height: "100%",
        color: "#3023BD",
        fontSize: '1rem',
        fontWeight: "700",
        background: "#fff",
      }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <div className={styles.mobileLogo}>
        <Logo logo={'nav'} alt={'Logo Madaseg em navegação modo mobile'} />
      </div>
      <Divider />
      <List>
        {[
          { id: 1, seguro: false, text: "sobre nós", href: "/sobre-nos" },
          { id: 2, seguro: false, text: "gestão", href: "/gestao" },
          { id: 3, seguro: false, text: "seguros:", href: "" },
          { id: 4, seguro: true, text: "residencial", img: iconeResidencial, alt: 'icone residencial', href: "/seguros/residencial" },
          { id: 5, seguro: true, text: "empresarial", img: iconeEmpresarial, alt: 'icone empresarial', href: "/seguros/empresarial" },
          { id: 6, seguro: true, text: "vida", img: iconeVida, alt: 'icone vida', href: "/seguros/vida" },
          { id: 7, seguro: true, text: "odontológico", img: iconeOdonto, alt: 'icone odonto', href: "/seguros/odontologico" },
          { id: 8, seguro: true, text: "bike", img: iconeBike, alt: 'icone bike', href: "/seguros/bike" },
          { id: 9, seguro: true, text: "auto", img: iconeAuto, alt: 'icone auto', href: "/seguros/auto" },
          !user ? { id: 10, seguro: false, text: "abrir conta", href: `${process.env.NEXT_PUBLIC_HOST}entrar/cadastrar` } : {},
          { id: 11, seguro: false, text: user ? `Olá ${user}` : "entrar", href: user ? `${process.env.NEXT_PUBLIC_HOST}dashboard` : `${process.env.NEXT_PUBLIC_HOST}entrar` },
        ].map((item) => (
          <ListItem className={item.seguro ? 'seguro' : 'itensNav'} disablePadding key={item.text}>
            <ListItemButton component="a" onClick={() => router.push(item.href)}>
              <img src={item.img} alt={item.alt} />
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
        <Divider />
      </List>
    </Box>
  );

  React.useEffect(() => {
    setTimeout(() => {
      if (sessionStorage.token && sessionStorage.nome) {
        setUser(sessionStorage.nome.replace(/ .*/, ''))
      }
    }, 300)
  })

  return (
    <section className={styles.nav}>
      <header className={styles.header}>
        <nav className={styles.navbar}>
          <div className={styles.logoNav}>
            <a onClick={() => {
              router.push({
                pathname: '/',
              })
            }}><Logo logo={'nav'} alt={'Logo Madaseg em navegação'} /></a>
          </div>
          {size.width <= 1199 ? (
            <div>
              <React.Fragment key={"right"}>
                <div className={styles.areaBars}>
                  <Button
                    className={styles.bars}
                    onClick={toggleDrawer("right", true)}
                  >
                    <DehazeOutlinedIcon />
                  </Button>
                </div>
                <Drawer
                  anchor={"right"}
                  open={state["right"]}
                  onClose={toggleDrawer("right", false)}
                >
                  {list("right")}
                </Drawer>
              </React.Fragment>
            </div>
          ) : (
            <ul className={styles.navMenu}>
              <li className={styles.navItem}>
                <a onClick={() => {
                  router.push({
                    pathname: '/sobre-nos',
                  })
                }} className={router.pathname == "/sobre-nos" ? styles.active : ""}>sobre nós</a>
              </li>
              <li className={styles.navItem}>
                <Menu />
              </li>
              <li className={styles.navItem}>
                <a onClick={() => {
                  router.push({
                    pathname: '/gestao',
                  })
                }} className={router.pathname == "/gestao" ? styles.active : ""}>gestão</a>
              </li>
              {user ? '' :
                <li className={styles.navItem}>
                  <div className={styles.hrVertical}></div>
                </li>
              }
              {user ? '' :
                <li className={styles.abrirConta}>
                  <Link passHref href={`${process.env.NEXT_PUBLIC_HOST}entrar/cadastrar`}>
                    <a href=''>abrir conta</a>
                  </Link>
                </li>
              }
              <li>
                <Link passHref href={user ? `${process.env.NEXT_PUBLIC_HOST}dashboard` : `${process.env.NEXT_PUBLIC_HOST}entrar`}>
                  <a className={styles.btnLink}>
                    {
                      user ? user : 'entrar'
                    }
                  </a>
                </Link>
              </li>
            </ul>
          )}
        </nav>
      </header>
    </section>
  );
};

export default withRouter(Header);
